import type { Action } from "../../actions/types";

export type StoreState = boolean;

export const initialState = false;

export function reducer(
  state: StoreState = initialState,
  action: Action
): StoreState {
  switch (action.type) {
    case "LOYALTYQUEST_TOKEN_FAILURE":
    case "LOYALTYQUEST_TOKEN_SUCCESS":
      return false;

    case "LOYALTYQUEST_TOKEN_REQUEST":
      return true;

    default:
      return state;
  }
}
